<template>
    <rkm-modal
        :buttons="['cancel', 'save']"
        :loading="loading"
        @save="$refs.Form.save()"
        extra-large
        ref="RkmModal"
        title="Cadastro de bairro"
    >
        <Form
            :estado_id="estado_id"
            :municipio_id="municipio_id"
            :municipio_nome="municipio_nome"
            @save="handleExit"
            ref="Form"
        />
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Vuex.
import { mapGetters } from 'vuex'

export default {
    components: { Form },
    computed: {
        ...mapGetters(['getLoading']),
        loading() {
            return this.getLoading('cadastro-bairro-form')
        },
    },
    data: () => ({
        estado_id: null,
        municipio_id: null,
        municipio_nome: null,
    }),
    methods: {
        open(bairro) {
            this.estado_id = bairro.estado_id
            this.municipio_id = bairro.municipio_id
            this.municipio_nome = bairro.municipio_nome
            this.$refs.RkmModal.show()
        },
        handleExit(bairro) {
            this.$emit('save', bairro)
            this.$refs.RkmModal.hide()
        },
    }
}
</script>